import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { HttpClient } from "@angular/common/http";
import * as _ from "lodash";
import { HomeService } from "../home/home.services";

@Component({
  selector: "app-fileupload",
  templateUrl: "./fileupload.component.html",
  styleUrls: ["./fileupload.component.scss"],
})
export class FileuploadComponent implements OnInit {
  @ViewChild("UploadFileInput", { static: false }) uploadFileInput: ElementRef;
  fileUploadForm: FormGroup;
  fileInputLabel: string;
  email: any;
  constructor(
    private formBuilder: FormBuilder,
    public toastr: ToastrService,
    private homeservie: HomeService
  ) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.fileUploadForm = this.formBuilder.group({
      myfile: [""],
    });
  }

  onFileSelect(event) {
    let af = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "text/csv",
    ];
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log(file);
      if (!_.includes(af, file.type)) {
        alert("Only Excel Or CSV Allowed!");
      } else {
        this.fileInputLabel = file.name;
        this.fileUploadForm.get("myfile").setValue(file);
      }
    }
  }

  onFormSubmit() {
    if (!this.fileUploadForm.get("myfile").value) {
      alert("Please fill valid details!");
      return false;
    }
    const formData = new FormData();
    formData.append("file", this.fileUploadForm.get("myfile").value);
    this.homeservie.uploadPDF(formData, this.email).subscribe((response) => {
      if ((response["status"] = "success")) {
        this.toastr.success("File uploaded sucessfully", "");
      }
    });
  }
}
